import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import colors from '../../utils/colors';
import { AUTO_PLAN_FEEDBACK, DATES_PLANNED, EMAIL, FEEDBACK, ID, SEARCH_BY_EMAIL } from '../../utils/constants/labels';
import PageHeader from '../common/layout/PageHeader';
import Table from '../common/table/Table';
import { api } from '../../api/api';
import { debounce } from '../../utils/common';
import { RegularText } from '../../utils/typography';
import { DatePreview } from '../../utils/helpers';
import { DATE_FORMAT, formatDate } from '../../utils/timeUtils';

const columns = [
  {
    title: ID,
    dataIndex: 'id',
    sorter: true,
    width: '5%'
  },
  {
    title: EMAIL,
    dataIndex: 'email',
    width: '20%'
  },
  {
    title: DATES_PLANNED,
    dataIndex: 'rangeFrom',
    width: '15%',
    render: (value, row) => (
      <DatePreview>
        {formatDate(value, DATE_FORMAT)} – {formatDate(row.rangeTo, DATE_FORMAT)}
      </DatePreview>
    )
  },
  {
    title: FEEDBACK,
    dataIndex: 'text',
    width: '45%',
    render: value => <Feedback>{value}</Feedback>
  },
  {
    title: 'Sent',
    dataIndex: 'createdAt',
    sorter: true,
    width: '15%',
    render: value => (value ? <DatePreview>{formatDate(value, DATE_FORMAT)}</DatePreview> : null)
  }
];

type Props = {};

const AutoPlanFeedback: FC<Props> = ({}) => {
  const [email, setEmail] = useState('');

  const setEmailDebounced = debounce(value => setEmail(value), 400);

  return (
    <Container>
      <PageHeader
        title={AUTO_PLAN_FEEDBACK}
        extra={[
          <Input
            key={1}
            onChange={e => setEmailDebounced(e.target.value)}
            placeholder={SEARCH_BY_EMAIL}
            prefix={<SearchOutlined />}
          />
        ]}
      />
      <Table
        columns={columns}
        getData={api.getAutoPlanFeedback}
        idPropName={'id'}
        searchPropName={'email'}
        searchPropValue={email}
        defaultSortingProp={'createdAt'}
      />
    </Container>
  );
};

export default AutoPlanFeedback;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background-color: ${colors.white};
  position: relative;
`;

// Students write sentences, so the cell wraps rather than truncating what they said.
const Feedback = styled(RegularText)`
  display: inline-block;
  white-space: pre-wrap;
  word-break: break-word;
`;
